import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const Services = ({color}) => {
  const data = useStaticQuery(graphql`
  query{
    
    img1: file(relativePath: { eq: "Zoom_Icon-1_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img2: file(relativePath: { eq: "Zoom_Icon-2_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img3: file(relativePath: { eq: "Zoom_Icon-3_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img4: file(relativePath: { eq: "Zoom_Icon-4_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img5: file(relativePath: { eq: "Zoom_Icon-5_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img6: file(relativePath: { eq: "Zoom_Icon-6_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img7: file(relativePath: { eq: "Zoom_Icon-7_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img8: file(relativePath: { eq: "Zoom_Icon-8_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img9: file(relativePath: { eq: "Zoom_Icon-9_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img10: file(relativePath: { eq: "Zoom_Icon-10_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img11: file(relativePath: { eq: "Zoom_Icon-11_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    img12: file(relativePath: { eq: "Zoom_Icon-12_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
  }
  `)

  const service_data = {
    executive:{
      title:"Executive Search",
      body:"Specialists who partner with your business to recruit leaders.",
      img:"img7"
    },
    succession:{
      title:"Succession Planning",
      body:"Plan for your company’s future and identify gaps and barriers for leadership success.",
      img:"img5"
    },
    onboarding:{
      title:"Recruitment and Onboarding",
      body:"Hiring for all levels, industries and functions. Providing resources and transition support.",
      img:"img6"

    },support:{
      title:"Human Resources Generalist Support",
      body:"Day to day employee relations assistance and general HR guidance.",
      img:"img1"

    },leadership:{
      title:"Leadership Development and Talent Management",
      body:"Groom your top talent and develop future leadership.",
      img:"img2"
    },
    compensation:{
      title:"Compensation Reviews and Recommendations",
      body:"Design of new plan, job evaluations and review of existing structure.",
      img:"img3"
    },
    organizational:{
      title:"Organizational Design",
      body:"Helping you to plan for your organizations needs and structure.",
      img:"img4"
    },
    coaching:{
      title:"Coaching",
      body:"Manager and executive coaching from certified coaches.",
      img:"img8"
    },
    termination:{
      title:"Termination Support",
      body:"Recommendations on obligations and support for affected employees.",
      img:"img9"
    },
    training:{
      title:"Training and Learning",
      body:"Development of training materials and facilitation of courses.",
      img:"img10"
    },
    engagement:{
      title:"Employee Engagement",
      body:"Surveys, trackers, reward and recognition plans.",
      img:"img11"
    },
    policies:{
      title:"Policies and Templates",
      body:"Employee handbooks and forms.",
      img:"img12"
    }
  }


  return (<ul className={`service-list parallax`} data-speed={0.5}>
    {`executive,succession,onboarding,support,leadership,compensation,organizational,coaching,termination,training,engagement,policies`.split(`,`).map((service, i) => (
      <li key={`service-part-${i}`}>
        <div className={`service-inner `}>
          <Img className={`service-image`} tag={`div`} fluid={data[service_data[service].img].childImageSharp.fluid}/>
          <h3 className={`blue-text`}>{service_data[service].title}</h3>
          <p>{service_data[service].body}</p>
        </div>
      </li>
      // <li key={`header-social-${i}`}><a href={social_url[channel]}><Img fluid={`${data[channel]}${color}`}/></a></li>
    ))}
  </ul>)
}




export default Services
